import { FreeTextPollComponent, FreeTextPollController } from './free_text_poll/free_text_poll';
import { MultiplePollComponent, MultiplePollController } from './multiple_poll/multiple_poll';
import { PollContainerComponent } from './poll_container/poll_container';
import { PollResultsComponent } from './results/poll_results/poll_results_component';
import { PollResultsController } from './results/poll_results/poll_results_controller';
import {
  PollResultsPieComponent,
  PollResultsPieController
} from './results/poll_results_pie/poll_results_pie_controller';
import { StandAloneChoicePoll, StandAloneChoicePollController } from './stand_alone_choice/stand_alone_choice';

angular
  .module('capability-ng-poll')
  .controller('StandAloneChoicePollController', StandAloneChoicePollController)
  .component('standAloneChoicePoll', new StandAloneChoicePoll())
  .controller('MultiplePollController', MultiplePollController)
  .component('multiplePoll', new MultiplePollComponent())
  .controller('FreeTextPollController', FreeTextPollController)
  .component('freeTextPoll', new FreeTextPollComponent())
  .controller('PollResultsController', PollResultsController)
  .component('pollResults', new PollResultsComponent())
  .controller('PollResultsPieController', PollResultsPieController)
  .component('pollResultsPie', new PollResultsPieComponent())
  .component('pollContainer', new PollContainerComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/poll_components_module.ts